// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ExpandableClamp__label":"bbr_a bhr_hi bhr_sa bhr_xl"};